module.exports = __webpack_public_path__ + "assets/img/tab.0db4ca82.png";